<template>
  <div>
    <p>
      This notification is pending certification because the following parties on this notification have not logged in and certified their involvement on this FON:
    </p>
    <b-list-group>
      <b-list-group-item
        v-for="certification in certifications"
        v-if="certification.declined ==null"
        class="mb-3 custom-radius"
        :key="(certification.contact || certification.user).id"
        :variant="'warning'"
      >
        <div class="row " :class="isExtraSmall ? 'flex-dir-col' : ''" v-if="certification.emailedAt == null || certification.emailedAt == ''">
          <div class="pending_user_info_wrapper">
            <span :class="isExtraSmall ? 'newline' : ''">{{(certification.user).firstName}} {{(certification.user).lastName}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">(</span>
            <span :class="isExtraSmall ? 'newline' : ''">Phone: {{(certification.user).phoneNumber}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">, </span>
            <span :class="isExtraSmall ? 'newline' : ''">Email: {{(certification.user).email}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">)</span>
          </div>
          <div class="d-flex justify-content-end pending_user_btn_wrapper" :class="isExtraSmall ? 'btn-max' : ''">
            <b-button v-if="canSeeEmailButton" :id="(certification.user).id" class="w-30 w-sm-auto email_btn" :class="isExtraSmall ? 'btn-max' : ''" @click="sendPartyUserEmail((certification.user).id)" arial-label="Send Email">Send Email</b-button>
          </div>
        </div>
        <div class="row " :class="isExtraSmall ? 'flex-dir-col' : ''" v-else>
          <div class="pending_user_info_wrapper">
            <span :class="isExtraSmall ? 'newline' : ''">{{(certification.user).firstName}} {{(certification.user).lastName}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">(</span>
            <span :class="isExtraSmall ? 'newline' : ''">Phone: {{(certification.user).phoneNumber}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">, </span>
            <span :class="isExtraSmall ? 'newline' : ''">Email: {{(certification.user).email}}</span>
            <span :class="isExtraSmall ? '_hide' : ''">)</span>
            <span :class="isExtraSmall ? 'newline' : ''"> (Sent: {{certification.emailedAt}})</span>
          </div>
          <div class="d-flex justify-content-end pending_user_btn_wrapper" :class="isExtraSmall ? 'btn-max' : ''">
            <b-button v-if="canSeeEmailButton" :disabled="true" class="w-30 w-sm-auto email_btn" :class="isExtraSmall ? 'btn-max' : ''" aria-label="Reminder has been sent">Reminder has been sent</b-button>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
    <p>
      You may wish to contact them to complete their certification.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CertificationParties',
  computed: {
    ...mapState(['isExtraSmall']),
    ...mapState('Notification', {
      certifications: state => state.certifications,
    }),
    canSeeEmailButton() {
      return this.$parent.$parent.$parent.mfsAdmin
        || (this.$parent.$parent.$parent.notification.landownerUser.id === this.$parent.$parent.$parent.user.id)
        || (this.$parent.$parent.$parent.notification.designatedAgentUser.id === this.$parent.$parent.$parent.user.id);
    },
  },
  methods: {
    async sendPartyUserEmail(id) {
      const emailInfo = { notificationId: this.$parent.$parent.$parent.notification.id, delinquentUserId: id };
      const targetBtn = document.getElementById(id);
      targetBtn.innerHTML = 'Sending...';
      targetBtn.disabled = true;
      await this.$store.dispatch('Notification/sendPartyUserEmail', emailInfo);
      targetBtn.innerHTML = 'Reminder has been sent';
      this.$emit('sendPartyUserEmail');
    },
  },
  data() {
    return {
      fullUrl: '/',
    };
  },
  created() {
    this.fullUrl = new URL(window.location.pathname, window.location.origin).href;
    this.$store.dispatch('Notification/fetchCertifications');
  },
};
</script>
<style>
.email_btn {
    line-height: 1;
}
.pending_user_info_wrapper{
  flex-basis: 75%;
}
.pending_user_btn_wrapper{
  flex-basis: 25%;
}
.custom-radius{
  border: 1px solid #F5961D !important;
  border-radius: 5px;
  background-color: #ffeaad;
}
.delinq-text{
  align-items: center;
}
.btn-max{
  width: 100% !important;
}
.newline{
  display: block;
  font-size: .9em;
  word-wrap: break-word;
  word-break: break-word;
}
._hide{
  display: none;
}
</style>
